module.exports = __webpack_public_path__ + "static/media/Bell-Notifications-On.acebfda8.png";